<div class="flex items-center justify-between gap-[1rem] px-[1rem] py-[1rem] max-sm:flex-col max-sm:items-stretch"
     [class]="dialogState.isHidden()
       ? 'bg-gradient-to-l from-(--p-other-gray-200) to-(--p-gray-300)'
       : 'bg-gradient-to-r from-(--p-primary-600) to-(--p-primary-300)'">
  @let activeFill = dialogState.isHidden() ? 'bg-(--p-other-gray-50)' : 'bg-(--p-surface-100)';

  <div #stepper class="c-no-scrollbar flex min-w-0 items-stretch overflow-x-auto rounded-[0.5rem] max-sm:w-full">
    @for (stage of stages; track stage; let first = $first; let last = $last) {
      @let shape = first
        ? '[clip-path:polygon(0_0,calc(100%_-_0.75rem)_0,100%_50%,calc(100%_-_0.75rem)_100%,0_100%)] pl-[0.625rem] pr-[1.25rem]'
        : last
          ? '[clip-path:polygon(0_0,100%_0,100%_100%,0_100%,0.75rem_50%)] pl-[1.375rem] pr-[1rem] -ml-[0.6875rem] rounded-r-[0.5rem]'
          : '[clip-path:polygon(0_0,calc(100%_-_0.75rem)_0,100%_50%,calc(100%_-_0.75rem)_100%,0_100%,0.75rem_50%)] pl-[1.375rem] pr-[1.25rem] -ml-[0.6875rem]';

      @let fill = isActiveStage(stage)
        ? activeFill + ' text-(--p-primary-600)'
        : 'bg-(--p-other-opacity-white-15) text-(--p-surface-0)';

      <div class="flex shrink-0 items-center gap-[0.5rem] py-[0.5rem] !mr-[0.0625rem]"
           [class]="shape + ' ' + fill">
        <gc-icon-badge [iconSrc]="stageIcons[stage]"
                       [alt]="stageLabels[stage] | translate"
                       [background]="stageBackground(stage)"
                       size="1.5rem"></gc-icon-badge>

        <span class="text-[0.6875rem] font-medium leading-[150%] whitespace-nowrap" [translate]="stageLabels[stage]"></span>
      </div>
    }
  </div>

  <p-button severity="contrast"
            class="shrink-0 max-sm:w-full"
            [outlined]="true"
            styleClass="!h-[2rem] !px-[0.75rem] !gap-[0.5rem] !rounded-[0.25rem] !border-(--p-surface-0) !bg-(--p-surface-0) !text-(--p-blue-500) hover:!bg-(--p-surface-50) max-sm:!w-full"
            (onClick)="drawer.toggle($event)">
    <span class="text-[0.75rem] font-semibold whitespace-nowrap" translate="@@fp-event-status-bar__change-status"></span>
    <svg-icon [src]="isDrawerOpen() ? 'icons/icon-accordion-arrow-up.svg' : 'icons/icon-accordion-arrow-down.svg'"
              [name]="isDrawerOpen() ? 'icon-accordion-arrow-up' : 'icon-accordion-arrow-down'"
              class="block size-[0.625rem]"></svg-icon>
  </p-button>
</div>

<p-popover #drawer
           appendTo="body"
           autoZIndex="false"
           styleClass="before:hidden after:hidden z-app-overlay-0 !rounded-[0.5rem] !shadow-[0_0.25rem_1.5rem_0_var(--p-other-opacity-black-25)] overflow-hidden"
           (onShow)="isDrawerOpen.set(true); alignAboveRight(drawer)"
           (onHide)="isDrawerOpen.set(false)">
  <div class="flex w-[13.15rem] flex-col py-1 px-1">
    @for (entry of entries(); track $index) {
      @if (entry.separatorBefore) {
        <div class="my-[0.25rem] h-[1px] w-full bg-(--p-primary-50)"></div>
      }

      @if (entry.kind === MenuEntryKind.Group) {
        <div class="flex items-center gap-[0.75rem] px-[0.5rem] py-[0.5rem]">
          <gc-icon-badge [iconSrc]="entry.heading.icon"
                         [alt]="entry.heading.label | translate"
                         [background]="entry.background"
                         size="1.75rem"></gc-icon-badge>

          <span class="text-[0.6875rem] font-medium leading-[150%] text-(--p-gray-950)" [translate]="entry.heading.label"></span>
        </div>

        <div class="relative ml-[1.75rem] flex flex-col pl-[0.75rem] pr-0 pb-[0.25rem] before:absolute before:left-0 before:top-0 before:h-[calc(99%-1.375rem)] before:border-l-1 before:border-dashed before:border-(--p-blue-100) before:content-['']">
          @for (action of entry.actions; track action.action) {
            <p-button [text]="true"
                      severity="contrast"
                      class="relative flex w-full before:absolute before:left-[-0.75rem] before:top-0 before:bottom-0 before:my-auto before:h-[1px] before:w-[0.75rem] before:border-b-1 before:border-dashed before:border-(--p-blue-100) before:content-['']"
                      styleClass="!w-full !justify-start !gap-[0.75rem] !rounded-[0.5rem] !px-[0.5rem] !py-[0.375rem] !text-left !border-none hover:!bg-(--p-neutral-500)"
                      (onClick)="selectAction(action.action); drawer.hide()">
              <gc-icon-badge [iconSrc]="action.icon"
                             [alt]="action.label | translate"
                             [background]="action.background"
                             size="1.75rem"></gc-icon-badge>

              <span class="text-[0.6875rem] font-medium leading-[150%] text-(--p-gray-950)" [translate]="action.label"></span>
            </p-button>
          }
        </div>
      } @else {
        <p-button [text]="true"
                  severity="contrast"
                  class="flex w-full"
                styleClass="!w-full !justify-start !gap-[0.75rem] !rounded-1 !px-[0.75rem] !py-[0.5rem] !text-left !border-none hover:!bg-(--p-neutral-500)"
                  (onClick)="selectAction(entry.action.action); drawer.hide()">
          <gc-icon-badge [iconSrc]="entry.action.icon"
                         [alt]="entry.action.label | translate"
                         [background]="entry.action.background"
                         size="1.75rem"></gc-icon-badge>

          <span class="text-[0.6875rem] font-medium leading-[150%] text-(--p-gray-950)" [translate]="entry.action.label"></span>
        </p-button>
      }
    }
  </div>
</p-popover>
